import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { to: '/', label: '首页' },
  { to: '/reading-modes', label: '阅读模式' },
  { to: '/comics', label: '漫画库' },
  { to: '/faq', label: '常见问题' },
  { to: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  const onDark = pathname === '/reading-modes';

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? onDark
            ? 'bg-background-950/95 backdrop-blur border-b border-background-800'
            : 'bg-background-50/95 backdrop-blur border-b border-background-200'
          : 'bg-transparent'
      }`}
    >
      <nav
        aria-label="主导航"
        className="mx-auto flex h-16 md:h-20 max-w-7xl items-center justify-between px-4 md:px-6"
      >
        <Link to="/" className="flex items-center gap-2" aria-label="漫蛙漫画网首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-book-2-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl font-bold tracking-tight ${
              onDark && !scrolled ? 'text-background-50' : 'text-foreground-950'
            }`}
          >
            漫蛙漫画
          </span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => {
            const active = link.to === pathname;
            return (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active
                    ? 'bg-primary-500 font-medium text-background-50'
                    : onDark && !scrolled
                      ? 'text-background-100 hover:bg-background-800 hover:text-background-50'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/comics"
            className="flex h-10 w-10 items-center justify-center rounded-full border text-base transition-colors"
            style={{ borderColor: onDark && !scrolled ? 'oklch(var(--background-700))' : 'oklch(var(--background-200))' }}
            aria-label="搜索漫画"
          >
            <i className={`ri-search-line ${onDark && !scrolled ? 'text-background-100' : 'text-foreground-700'}`}></i>
          </Link>
          <Link
            to="/comics"
            className="whitespace-nowrap rounded-full bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600"
          >
            开始阅读
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className={`flex h-10 w-10 items-center justify-center rounded-full border text-lg md:hidden ${
            onDark && !scrolled
              ? 'border-background-700 text-background-100'
              : 'border-background-200 text-foreground-700'
          }`}
          aria-label={open ? '关闭菜单' : '打开菜单'}
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => {
              const active = link.to === pathname;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`rounded-lg px-4 py-2.5 text-sm ${
                    active
                      ? 'bg-primary-500 font-medium text-background-50'
                      : 'text-foreground-700 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/comics"
              className="mt-2 rounded-lg bg-accent-500 px-4 py-2.5 text-center text-sm font-medium text-background-50"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}